import React from 'react';
import { PiTrademarkRegistered } from "react-icons/pi";

const FooterAbout = () => {
    return (
        <div className="footer-about">
            <img src="/assets/svgs/MarketrackHomeLogo.svg" alt="" />
            <p className="footer-about-para">
                Marketrack aims to develop an investment copilot with cutting-edge technologies to address the challenges of limited time, tools and financial complexity for retail investors, thus democratizing & leveling the playing field with institutions.
            </p>
            <p className="footer-trademark">
                Marketrack<sup><PiTrademarkRegistered /></sup> is a registered trademark of Dellarex Technologies Pvt Ltd in India. All Rights Reserved.
            </p>
        </div>
    );
};

export default FooterAbout;